import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from '../../../../components/CustomTextInput';
import { Helpers } from '../../../../helpers/Helpers';
import { GetAntrepoInByIdResponseAntrepoInVehicle, GetAntrepoInByIdResponseAntrepoInVehicleProduct, GetAntrepoInByIdResponseAntrepoInVehicleService } from '../../../../models/response/antrepoIn/GetAntrepoInByIdResponse';
import { GetConstantListResponse } from '../../../../models/response/constant/GetConstantListResponse';
import { storeActivityIndicator, storeAreYouSureModalCallback, storeFastFirm } from '../../../../redux/reducers/authSlice';
import { CompanyService } from '../../../../services/CompanyService';
import { ConstantService } from '../../../../services/ConstantService';
import { ContainerService } from '../../../../services/ContainerService';
import { VehicleService } from '../../../../services/VehicleService';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { AddVehicleRequest } from '../../../../models/request/vehicle/AddVehicleRequest';
import { AddVehicleResponse } from '../../../../models/response/vehicle/AddVehicleResponse';
import CustomMultiSelect, { CustomMultiSelectModel } from '../../../../components/CustomMultiSelect';
import { GetWelcomeListResponse, GetWelcomeListResponseData } from '../../../../models/response/welcome/GetWelcomeListResponse';
import { AntrepoAreaTypeEnum, PersonnelDutyEnum, WelcomeStatusEnum } from '../../../../models/common/Enums';
import { WelcomeService } from '../../../../services/WelcomeService';
import moment from 'moment';
import { AntrepoOutService } from '../../../../services/AntrepoOutService';
import { GetAntrepoOutListByAntrepoInIdResponse } from '../../../../models/response/antrepoOut/GetAntrepoOutListByAntrepoInIdResponse';
import { GetVehicleByIdResponse } from '../../../../models/response/vehicle/GetVehicleByIdResponse';
import { GetDriverByIdResponse } from '../../../../models/response/driver/GetDriverByIdResponse';
import { GetCompanyByIdResponse } from '../../../../models/response/company/GetCompanyByIdResponse';
import { PersonnelService } from '../../../../services/PersonnelService';
import { AntrepoService } from '../../../../services/AntrepoService';
import { GetAntrepoByIdResponse } from '../../../../models/response/antrepo/GetAntrepoByIdResponse';
import { DriverService } from '../../../../services/DriverService';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import CustomSwitch from '../../../../components/CustomSwitch';
import { RootState } from '../../../../redux/store';
import { useSelector } from 'react-redux';

interface Props {
    vehicleInformationRef: any
    antrepoInVehicles: GetAntrepoInByIdResponseAntrepoInVehicle[]
    setAntrepoInVehicles: React.Dispatch<React.SetStateAction<GetAntrepoInByIdResponseAntrepoInVehicle[]>>
    antrepoInVehicleProducts: GetAntrepoInByIdResponseAntrepoInVehicleProduct[]
    setAntrepoInVehicleProducts: React.Dispatch<React.SetStateAction<GetAntrepoInByIdResponseAntrepoInVehicleProduct[]>>
    antrepoInVehicleServices: GetAntrepoInByIdResponseAntrepoInVehicleService[]
    setAntrepoInVehicleServices: React.Dispatch<React.SetStateAction<GetAntrepoInByIdResponseAntrepoInVehicleService[]>>
    welcomeList: GetWelcomeListResponseData[]
    antrepoInId: string | undefined
    setWelcomeList: React.Dispatch<React.SetStateAction<GetWelcomeListResponseData[]>>
    ledgerNo: string | undefined
    selectedSenderFirm: CustomSingleSelectModel | undefined
    selectedReceiverFirm: CustomSingleSelectModel | undefined
    saveAntrepoIn: (_antrepoInVehicles?: GetAntrepoInByIdResponseAntrepoInVehicle[] | undefined, isFromWelcome?: boolean) => Promise<boolean>
    selectedAntrepo: CustomSingleSelectModel | undefined
    isDisabledFromLock: boolean
}

const VehicleInformation = ({
    vehicleInformationRef,
    antrepoInVehicles,
    setAntrepoInVehicles,
    antrepoInVehicleProducts,
    setAntrepoInVehicleProducts,
    antrepoInVehicleServices,
    setAntrepoInVehicleServices,
    welcomeList,
    antrepoInId,
    setWelcomeList,
    ledgerNo,
    selectedSenderFirm,
    saveAntrepoIn,
    selectedReceiverFirm,
    selectedAntrepo,
    isDisabledFromLock
}: Props) => {
    const auth = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch();
    const [selectedVehicle, setSelectedVehicle] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedTrailer, setSelectedTrailer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [containerNo, setContainerNo] = useState<string | undefined>(undefined);
    const [selectedContainer, setSelectedContainer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedRamp, setSelectedRamp] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [vehicleArriveDate, setVehicleArriveDate] = useState<string | undefined>(undefined);
    const [selectedSupplier, setSelectedSupplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [summaryDeclarationNo, setSummaryDeclarationNo] = useState<string | undefined>(undefined);
    const [transportDocumentNo, setTransportDocumentNo] = useState<string | undefined>(undefined);
    const [truckReportNo, setTruckReportNo] = useState<string | undefined>(undefined);
    const [summaryDeclarationOrderQuantity, setSummaryDeclarationOrderQuantity] = useState<string | undefined>(undefined);
    const [summaryDeclarationOrderNo, setSummaryDeclarationOrderNo] = useState<string | undefined>(undefined);
    const [summaryDeclarationDate, setSummaryDeclarationDate] = useState<string | undefined>(undefined);
    const [antrepoEnteranceDate, setAntrepoEnteranceDate] = useState<string | undefined>(undefined);
    const [antrepoInVehicleId, setAntrepoInVehicleId] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [isWelcomePanelOpen, setIsWelcomePanelOpen] = useState(false);
    const [selectedWelcomes, setSelectedWelcomes] = useState<CustomMultiSelectModel[]>([]);
    const [selectedEvacuationOfficer, setSelectedEvacuationOfficer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedOperator, setSelectedOperator] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDriver, setSelectedDriver] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [willNotBeInvoiced, setWillNotBeInvoiced] = useState(false);
    const [willNotBeInvoicedReason, setWillNotBeInvoicedReason] = useState<string | undefined>(undefined);

    const welcomeListHandler = async () => {
        try {
            if (!selectedReceiverFirm) {
                toast.error('Alıcı Firma alanını doldurunuz!');
                return;
            }

            dispatch(storeActivityIndicator(true));
            var defaultWelcomeStatus: CustomSingleSelectModel | undefined = undefined;

            var response3: GetConstantListResponse = await ConstantService.getConstantList('WELCOME_STATUS', undefined, WelcomeStatusEnum.ARAC_GELDI);

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }

            if (response3.data.length > 0)
                defaultWelcomeStatus = ({ label: response3.data[0].value, value: response3.data[0].constantId, additionalValue1: response3.data[0].additionalValue1 })

            var response2: GetWelcomeListResponse = await WelcomeService.getWelcomeList(true, (defaultWelcomeStatus ? [defaultWelcomeStatus] : undefined), true, selectedReceiverFirm?.value);

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setWelcomeList(response2.data);
            setIsWelcomePanelOpen(true);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const setSelectedWelcomesToList = async () => {
        if (selectedWelcomes.length > 0) {
            var oldList: GetAntrepoInByIdResponseAntrepoInVehicle[] = JSON.parse(JSON.stringify(antrepoInVehicles));

            var nextGroupNo = (oldList.length == 0 ? 1 : Math.max(...oldList.filter(x => x.groupNo && x.groupNo.toString().trim() != '').map(x => parseInt(x.groupNo + ''))) + 1);

            var tempAntrepoInVehicleList: GetAntrepoInByIdResponseAntrepoInVehicle[] = welcomeList.filter(x => selectedWelcomes.map(x => x.value).includes(x.welcomeId)).map(function (x) {
                return {
                    groupNo: (nextGroupNo++).toString(),
                    trailerId: x.trailerId,
                    vehicleId: x.vehicleId,
                    containerNo: x.containerNo,
                    vehicleArriveDate: x.vehicleArriveDate,
                    supplierId: x.supplierId,
                    welcomeId: x.welcomeId,
                    antrepoInVehicleId: Helpers.generateUUID(true),
                    containerId: undefined,
                    summaryDeclarationDate: undefined,
                    antrepoEnteranceDate: undefined,
                    summaryDeclarationNo: undefined,
                    summaryDeclarationOrderNo: undefined,
                    summaryDeclarationOrderQuantity: undefined,
                    transportDocumentNo: undefined,
                    truckReportNo: undefined,
                    trailerName: x.trailerName,
                    containerName: undefined,
                    isSelected: false,
                    supplierName: x.supplierName,
                    vehicleName: x.vehicleName,
                    evacuationOfficerId: undefined,
                    evacuationOfficerName: undefined,
                    rampId: undefined,
                    rampName: undefined,
                    operatorId: undefined,
                    operatorName: undefined,
                    willNotBeInvoiced: false,
                    willNotBeInvoicedReason: undefined,
                    driverId: x.driverId,
                    driverName: x.driverName,
                    lastInvoicedDate: undefined,
                }
            });

            oldList = [...oldList, ...tempAntrepoInVehicleList];

            if (!(await saveAntrepoIn(oldList, true))) {
                return;
            }
        }

        setSelectedWelcomes([]);
        setIsWelcomePanelOpen(false);
    }

    const saveVehicleOrTrailer = async (_insertedValue: string, _isVehicle: number, _isTrailer: number, _setFunction: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>) => {
        try {
            dispatch(storeActivityIndicator(true));

            var vehicleTypeId = undefined;

            var response5: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_TYPE', undefined, (_isTrailer == 1 ? '6' : selectedTrailer ? '2' : '4'));

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            if (response5.data.length > 0) {
                vehicleTypeId = { label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 };
            }

            var obj: AddVehicleRequest = {
                vehicleId: undefined,
                plate: _insertedValue,
                vehicleTypeId: vehicleTypeId?.value,
                vehicleOwnerId: undefined,
                driverId: undefined,
                isBlocked: 0,
                isCustomActive: 1,
                periodicalDocuments: [],
                fileArchives: [],
                vehiclePassCards: [],
                trailerId: _isTrailer == 1 ? undefined : selectedTrailer?.value
            }

            var response: AddVehicleResponse = await VehicleService.addVehicle(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            toast.success(response.message)
            _setFunction({ label: response.data.plate, value: response.data.vehicleId });
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const saveItem = async () => {
        if (selectedVehicle && Helpers.isEmpty(vehicleArriveDate)) {
            toast.error('Araç Geliş Tarihi alanını doldurunuz!');
        }
        // else if (selectedVehicle && Helpers.isEmpty(antrepoEnteranceDate)) {
        //     toast.error('Antrepo Giriş Tarihi alanını doldurunuz!');
        // }
        else if (!Helpers.isEmpty(vehicleArriveDate) && moment(vehicleArriveDate, 'YYYY-MM-DDTHH:mm') > moment()) {
            toast.error('Araç Geliş Tarihi alanını sistem tarihinden büyük olamaz!')
        }
        else if (!Helpers.isEmpty(antrepoEnteranceDate) && moment(antrepoEnteranceDate, 'YYYY-MM-DDTHH:mm') > moment()) {
            toast.error('Antrepo Giriş Tarihi alanını sistem tarihinden büyük olamaz!')
        }
        else if (!Helpers.isEmpty(antrepoEnteranceDate) && !selectedEvacuationOfficer) {
            toast.error('Tahliye Sorumlusu alanını doldurunuz!')
        }
        else if (!Helpers.isEmpty(antrepoEnteranceDate) && !selectedOperator) {
            toast.error('Operatör alanını doldurunuz!')
        }
        else if (!Helpers.isEmpty(antrepoEnteranceDate) && !selectedRamp) {
            toast.error('Rampa No alanını doldurunuz!')
        }
        else if (willNotBeInvoiced && Helpers.isEmpty(willNotBeInvoicedReason)) {
            toast.error('Faturalanmama Nedeni alanını doldurunuz!')
        }
        else {
            var oldList: GetAntrepoInByIdResponseAntrepoInVehicle[] = JSON.parse(JSON.stringify(antrepoInVehicles));

            if (Helpers.isEmpty(antrepoInVehicleId)) {
                var o: GetAntrepoInByIdResponseAntrepoInVehicle = {
                    antrepoInVehicleId: Helpers.generateUUID(true),
                    isSelected: false,
                    containerId: selectedContainer?.value,
                    containerName: selectedContainer?.label,
                    containerNo: containerNo,
                    groupNo: (antrepoInVehicles.length == 0 ? 1 : Math.max(...antrepoInVehicles.filter(x => x.groupNo && x.groupNo.toString().trim() != '').map(x => parseInt(x.groupNo + ''))) + 1).toString(),
                    summaryDeclarationDate: summaryDeclarationDate,
                    antrepoEnteranceDate: antrepoEnteranceDate,
                    summaryDeclarationNo: summaryDeclarationNo,
                    summaryDeclarationOrderNo: summaryDeclarationOrderNo,
                    summaryDeclarationOrderQuantity: summaryDeclarationOrderQuantity,
                    supplierId: selectedSupplier?.value,
                    supplierName: selectedSupplier?.label,
                    trailerId: selectedTrailer?.value,
                    trailerName: selectedTrailer?.label,
                    transportDocumentNo: transportDocumentNo,
                    truckReportNo: truckReportNo,
                    vehicleArriveDate: vehicleArriveDate,
                    vehicleId: selectedVehicle?.value,
                    vehicleName: selectedVehicle?.label,
                    welcomeId: undefined,
                    evacuationOfficerId: selectedEvacuationOfficer?.value,
                    evacuationOfficerName: selectedEvacuationOfficer?.label,
                    operatorId: selectedOperator?.value,
                    operatorName: selectedOperator?.label,
                    willNotBeInvoiced: willNotBeInvoiced,
                    willNotBeInvoicedReason: willNotBeInvoicedReason,
                    driverId: selectedDriver?.value,
                    driverName: selectedDriver?.label,
                    rampId: selectedRamp?.value,
                    rampName: selectedRamp?.label,
                    lastInvoicedDate: undefined
                }

                // setAntrepoInVehicles([...antrepoInVehicles, o])
                oldList = [...oldList, o];
            }
            else {
                oldList = oldList.map(function (x) {
                    if (x.antrepoInVehicleId == antrepoInVehicleId) {
                        x.isSelected = false;
                        x.containerId = selectedContainer?.value;
                        x.containerName = selectedContainer?.label;
                        x.containerNo = containerNo;
                        x.summaryDeclarationDate = summaryDeclarationDate;
                        x.antrepoEnteranceDate = antrepoEnteranceDate;
                        x.summaryDeclarationNo = summaryDeclarationNo;
                        x.summaryDeclarationOrderNo = summaryDeclarationOrderNo;
                        x.summaryDeclarationOrderQuantity = summaryDeclarationOrderQuantity;
                        x.supplierId = selectedSupplier?.value;
                        x.supplierName = selectedSupplier?.label;
                        x.trailerId = selectedTrailer?.value;
                        x.trailerName = selectedTrailer?.label;
                        x.transportDocumentNo = transportDocumentNo;
                        x.truckReportNo = truckReportNo;
                        x.vehicleArriveDate = vehicleArriveDate;
                        x.vehicleId = selectedVehicle?.value;
                        x.vehicleName = selectedVehicle?.label;
                        x.evacuationOfficerId = selectedEvacuationOfficer?.value;
                        x.evacuationOfficerName = selectedEvacuationOfficer?.label;
                        x.operatorId = selectedOperator?.value;
                        x.operatorName = selectedOperator?.label;
                        x.willNotBeInvoiced = willNotBeInvoiced;
                        x.willNotBeInvoicedReason = willNotBeInvoicedReason;
                        x.rampId = selectedRamp?.value;
                        x.rampName = selectedRamp?.label;
                        x.driverId = selectedDriver?.value;
                        x.driverName = selectedDriver?.label;
                    }

                    return x;
                });
            }

            if (await saveAntrepoIn(oldList)) {
                setAntrepoInVehicleId('');
                setSelectedVehicle(undefined);
                setSelectedTrailer(undefined);
                setContainerNo('');
                setSelectedContainer(undefined);
                setSelectedRamp(undefined);
                setSelectedEvacuationOfficer(undefined);
                setSelectedOperator(undefined);
                setWillNotBeInvoiced(false);
                setWillNotBeInvoicedReason('');
                setSelectedDriver(undefined);
                setVehicleArriveDate('');
                setSelectedSupplier(undefined);
                setTransportDocumentNo('');
                setTruckReportNo('');
                setSummaryDeclarationNo('');
                setSummaryDeclarationDate('');
                setAntrepoEnteranceDate('');
                setSummaryDeclarationOrderNo('');
                setSummaryDeclarationOrderQuantity('');
                setIsOpen(false);
                scrollTo();
            }
        }
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAntrepoInVehicleId('');
        setSelectedVehicle(undefined);
        setSelectedTrailer(undefined);
        setContainerNo('');
        setSelectedContainer(undefined);
        setSelectedRamp(undefined);
        setSelectedEvacuationOfficer(undefined);
        setSelectedOperator(undefined);
        setWillNotBeInvoiced(false);
        setWillNotBeInvoicedReason('');
        setSelectedDriver(undefined);
        setVehicleArriveDate('');
        setSelectedSupplier(undefined);
        setTransportDocumentNo('');
        setTruckReportNo('');
        setSummaryDeclarationNo('');
        setSummaryDeclarationDate('');
        setAntrepoEnteranceDate('');
        setSummaryDeclarationOrderNo('');
        setSummaryDeclarationOrderQuantity('');
        setIsOpen(false);
        scrollTo();
    }

    const setItemSelected = (_id: string) => {
        setAntrepoInVehicles(antrepoInVehicles.map(function (x) {
            if (x.antrepoInVehicleId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))

        setAntrepoInVehicleProducts(antrepoInVehicleProducts.map(function (x) {
            x.isSelected = false
            return x;
        }))

        setAntrepoInVehicleServices(antrepoInVehicleServices.map(function (x) {
            x.isSelected = false
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = antrepoInVehicles.length == antrepoInVehicles.filter(x => x.isSelected).length;

        setAntrepoInVehicles(antrepoInVehicles.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))

        setAntrepoInVehicleProducts(antrepoInVehicleProducts.map(function (x) {
            x.isSelected = false
            return x;
        }))

        setAntrepoInVehicleServices(antrepoInVehicleServices.map(function (x) {
            x.isSelected = false
            return x;
        }))
    }

    const deleteItems = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            for (var i = 0; i < antrepoInVehicles.filter(x => x.isSelected).length; i++) {
                if (antrepoInId) {
                    var response2: GetAntrepoOutListByAntrepoInIdResponse = await AntrepoOutService.getAntrepoOutListByAntrepoInId(antrepoInId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    if (response2.data.length > 0) {
                        toast.error(ledgerNo + ' defter numaralı giriş kayıdına ait çıkış kayıdı olduğu için silme yapılamaz!')
                        return;
                    }
                }

                var control = antrepoInVehicleProducts.find(x => x.groupNo == antrepoInVehicles.filter(x => x.isSelected)[i].groupNo);

                if (control) {
                    toast.error(antrepoInVehicles.filter(x => x.isSelected)[i].groupNo + ' grup numaralı araca bağlı ürün bulunduğu için silme yapılamaz!')
                    return;
                }

                var control2 = antrepoInVehicleServices.find(x => x.groupNo == antrepoInVehicles.filter(x => x.isSelected)[i].groupNo);

                if (control2) {
                    toast.error(antrepoInVehicles.filter(x => x.isSelected)[i].groupNo + ' grup numaralı araca bağlı ek hizmet bulunduğu için silme yapılamaz!')
                    return;
                }
            }

            saveAntrepoIn(antrepoInVehicles.filter(x => !x.isSelected), true);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const setUpdateItem = () => {
        var o = antrepoInVehicles.filter(x => x.isSelected)[0];

        setAntrepoInVehicleId(o.antrepoInVehicleId);
        setSelectedVehicle(o.vehicleId ? { label: o.vehicleName, value: o.vehicleId } : undefined);
        setSelectedTrailer(o.trailerId ? { label: o.trailerName, value: o.trailerId } : undefined);
        setContainerNo(o.containerNo);
        setSelectedContainer(o.containerId ? { label: o.containerName, value: o.containerId } : undefined);
        setSelectedRamp(o.rampId ? { label: o.rampName, value: o.rampId } : undefined);
        setSelectedEvacuationOfficer(o.evacuationOfficerId ? { label: o.evacuationOfficerName + '', value: o.evacuationOfficerId } : undefined);
        setSelectedOperator(o.operatorId ? { label: o.operatorName + '', value: o.operatorId } : undefined);
        setWillNotBeInvoiced(o.willNotBeInvoiced);
        setWillNotBeInvoicedReason(o.willNotBeInvoicedReason);
        setSelectedDriver(o.driverId ? { label: o.driverName + '', value: o.driverId } : undefined);
        setVehicleArriveDate(o.vehicleArriveDate);
        setSelectedSupplier(o.supplierId ? { label: o.supplierName, value: o.supplierId } : undefined);
        setTransportDocumentNo(o.transportDocumentNo);
        setTruckReportNo(o.truckReportNo);
        setSummaryDeclarationNo(o.summaryDeclarationNo);
        setSummaryDeclarationDate(o.summaryDeclarationDate);
        setAntrepoEnteranceDate(o.antrepoEnteranceDate);
        setSummaryDeclarationOrderNo(o.summaryDeclarationOrderNo);
        setSummaryDeclarationOrderQuantity(o.summaryDeclarationOrderQuantity);
        setIsOpen(true);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = vehicleInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const onVehicleChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            dispatch(storeActivityIndicator(true));
            if (selectedValue) {
                var response4: GetVehicleByIdResponse = await VehicleService.getVehicleById(selectedValue.value);

                if (!response4.isSuccess) {
                    toast.error(response4.message)
                    return;
                }

                var vehicle = response4.data;

                if (vehicle) {
                    if (vehicle.trailerId) {
                        var response3: GetVehicleByIdResponse = await VehicleService.getVehicleById(vehicle.trailerId);

                        if (!response3.isSuccess) {
                            toast.error(response3.message)
                            return;
                        }

                        var selectedTrailer = response3.data;

                        if (selectedTrailer)
                            setSelectedTrailer({ label: selectedTrailer.plate, value: selectedTrailer.vehicleId });
                        else
                            setSelectedTrailer(undefined)
                    }
                    else
                        setSelectedTrailer(undefined)

                    // if (vehicle.driverId) {
                    //     var response2: GetDriverByIdResponse = await DriverService.getDriverById(vehicle?.driverId);

                    //     if (!response2.isSuccess) {
                    //         toast.error(response2.message)
                    //         return;
                    //     }

                    //     var selectedDriver = response2.data;

                    //     if (selectedDriver && selectedDriver.nameSurname && selectedDriver.driverId)
                    //         setSelectedDriver({ label: selectedDriver.nameSurname, value: selectedDriver.driverId });
                    //     else
                    //         setSelectedDriver(undefined)
                    // }
                    // else
                    //     setSelectedDriver(undefined)

                    if (vehicle.vehicleOwnerId) {
                        var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(vehicle?.vehicleOwnerId);

                        if (!response.isSuccess) {
                            toast.error(response.message)
                            return;
                        }

                        var selectedSupplier = response.data;

                        if (selectedSupplier && selectedSupplier.name)
                            setSelectedSupplier({ label: selectedSupplier.name, value: selectedSupplier.companyId });
                        else
                            setSelectedSupplier(undefined)
                    }
                    else
                        setSelectedSupplier(undefined)
                }
                else {
                    setSelectedTrailer(undefined)
                    // setSelectedDriver(undefined)
                    setSelectedSupplier(undefined)
                }
            }
            else {
                setSelectedTrailer(undefined)
                // setSelectedDriver(undefined)
                setSelectedSupplier(undefined)
            }

            setSelectedVehicle(selectedValue);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getRampList = async () => {
        try {
            if (selectedAntrepo) {
                var response: GetAntrepoByIdResponse = await AntrepoService.getAntrepoById(selectedAntrepo.value)
                if (!response.isSuccess) {
                    toast.error(response.message)

                    return {
                        isSuccess: true,
                        data: []
                    };
                }

                return {
                    isSuccess: true,
                    data: response.data.antrepoAreas.filter(x => x.antrepoAreaTypeKey == AntrepoAreaTypeEnum.MAL_KABUL)
                };
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }

        return {
            isSuccess: true,
            data: []
        };
    }

    return (
        <div className='containerPart' ref={vehicleInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Araç Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Plaka</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicle}
                                            onChange={onVehicleChange}
                                            onMenuOpen={() => VehicleService.getVehicleList(["2", "4", "5"])}
                                            insertable={{
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveVehicleOrTrailer(_insertedValue, 1, 0, setSelectedVehicle);
                                                    }
                                                }
                                            }}
                                            labelName='plate'
                                            valueName='vehicleId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Dorse Plaka</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedTrailer}
                                            onChange={setSelectedTrailer}
                                            onMenuOpen={() => VehicleService.getVehicleList(["6", "7"])}
                                            insertable={{
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveVehicleOrTrailer(_insertedValue, 0, 1, setSelectedTrailer);
                                                    }
                                                }
                                            }}
                                            labelName='plate'
                                            valueName='vehicleId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Antrepo Giriş Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={antrepoEnteranceDate} onChange={(e) => { setAntrepoEnteranceDate(e.target.value); }} type="datetime-local" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Konteyner No</label>
                                        <CustomTextInput value={containerNo} setValue={setContainerNo} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Konteyner Tipi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedContainer}
                                            onChange={setSelectedContainer}
                                            onMenuOpen={() => ContainerService.getContainerList()}
                                            labelName='name'
                                            valueName='containerId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Geliş Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={vehicleArriveDate} onChange={(e) => { setVehicleArriveDate(e.target.value); }} type="datetime-local" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Tedarikçi Firma</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedSupplier}
                                            onChange={setSelectedSupplier}
                                            insertable={{
                                                tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                                onClick: () => {
                                                    dispatch(storeFastFirm({
                                                        companyId: selectedSupplier?.value,
                                                        isSupplier: true,
                                                        onSubmit: async (response) => {
                                                            setSelectedSupplier({ label: response.name, value: response.companyId })
                                                        }
                                                    }))
                                                }
                                            }}
                                            onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">T1 (Taşıma Senedi)</label>
                                        <CustomTextInput value={transportDocumentNo} setValue={setTransportDocumentNo} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Tır Karne No</label>
                                        <CustomTextInput value={truckReportNo} setValue={setTruckReportNo} />
                                    </div>
                                </div>


                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Özet Beyan No</label>
                                        <CustomTextInput value={summaryDeclarationNo} setValue={setSummaryDeclarationNo} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Özet Beyan Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={Helpers.isEmpty(summaryDeclarationDate) ? undefined : summaryDeclarationDate?.split('T')[0].split(' ')[0]} onChange={(e) => { setSummaryDeclarationDate(e.target.value); }} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Rampa No</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedRamp}
                                            onChange={setSelectedRamp}
                                            onMenuOpen={async () => await getRampList()}
                                            labelName='name'
                                            valueName='antrepoAreaId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Özet Beyan Sıra No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={summaryDeclarationOrderNo} onChange={(e) => { setSummaryDeclarationOrderNo(e.target.value); }} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Özet Beyan Adet</label>
                                        <CustomNumberInput value={summaryDeclarationOrderQuantity} setValue={setSummaryDeclarationOrderQuantity} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Tahliye Sorumlusu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedEvacuationOfficer}
                                            onChange={setSelectedEvacuationOfficer}
                                            onMenuOpen={() => PersonnelService.getPersonnelList([PersonnelDutyEnum.DEPOCU], true)}
                                            labelName='nameSurname'
                                            valueName='personnelId'
                                        />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Operatör</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedOperator}
                                            onChange={setSelectedOperator}
                                            onMenuOpen={() => PersonnelService.getPersonnelList([PersonnelDutyEnum.OPERATOR], true)}
                                            labelName='nameSurname'
                                            valueName='personnelId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Sürücü</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDriver}
                                            onChange={setSelectedDriver}
                                            onMenuOpen={() => DriverService.getDriverList()}
                                            labelName='nameSurname'
                                            valueName='driverId'
                                        />
                                    </div>

                                    {
                                        auth.user.user?.data.roles.find(x => x == "Giriş Faturalandırma İşlemi Yetkisi") && (
                                            <div className='col-md-4'>
                                                <Box flexDirection='row'>
                                                    <Box>
                                                        <label htmlFor="exampleFormControlInput1" className="form-label">Faturalanmayacak</label>
                                                        <CustomSwitch
                                                            setIsActive={() => {
                                                                if (willNotBeInvoiced)
                                                                    setWillNotBeInvoicedReason('');

                                                                setWillNotBeInvoiced(!willNotBeInvoiced)
                                                            }}
                                                            isActive={willNotBeInvoiced}
                                                        />
                                                    </Box>

                                                    {
                                                        willNotBeInvoiced && (
                                                            <Box ml='15px' flexGrow={1}>
                                                                <label htmlFor="exampleFormControlInput1" className="form-label required">Faturalanmama Nedeni</label>
                                                                <CustomTextInput value={willNotBeInvoicedReason} setValue={setWillNotBeInvoicedReason} />
                                                            </Box>
                                                        )
                                                    }
                                                </Box>
                                            </div>
                                        )
                                    }
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    {
                        !isDisabledFromLock && (
                            <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                                <Box flexDirection='row' flexGrow={1}>
                                    <Box height='32.5px' onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={"1"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                                        <Box mr="5px" justifyContent="center">
                                            <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                                        </Box>
                                        <Box justifyContent="center">
                                            <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                                        </Box>
                                    </Box>

                                    <Box height='32.5px' onClick={antrepoInVehicles.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoInVehicles.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                                        <Box mr="5px" justifyContent="center">
                                            <i className="text-white fa fa-edit" />
                                        </Box>
                                        <Box justifyContent="center">
                                            <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                                        </Box>
                                    </Box>

                                    <Box height='32.5px' onClick={antrepoInVehicles.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={antrepoInVehicles.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                        <Box mr="5px" justifyContent="center">
                                            <i className="text-white fa fa-trash" />
                                        </Box>
                                        <Box justifyContent="center">
                                            <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                                        </Box>
                                    </Box>
                                </Box>

                                {
                                    (!isWelcomePanelOpen) && (
                                        <Box height='32.5px' onClick={() => welcomeListHandler()} className={"actionIcon p-2"} opacity={"1"} bg={'orange'} justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center">
                                                <i className={"text-white fa fa-upload"} />
                                            </Box>
                                            <Box justifyContent="center">
                                                <span style={{ fontWeight: 600 }} className="text-white">Karşılamadan Getir</span>
                                            </Box>
                                        </Box>
                                    )
                                }

                                {
                                    isWelcomePanelOpen && (
                                        <Box alignItems='center' flexDirection='row'>
                                            <Box width='750px' mr='10px'>
                                                <CustomMultiSelect
                                                    onChange={setSelectedWelcomes}
                                                    selectedValues={selectedWelcomes}
                                                    onMenuOpen={async () => {
                                                        return {
                                                            isSuccess: true,
                                                            data: welcomeList.map(function (x) {
                                                                return { label: [x.refNo, x.customerName, x.vehicleName, x.trailerName, x.welcomeStatusName, (x.isOut ? 'Antrepo Tahliye' : 'Antrepo Yükleme')].filter(x => x && !Helpers.isEmpty(x)).join(' - '), value: x.welcomeId }
                                                            })
                                                        }
                                                    }}
                                                    labelName='label'
                                                    valueName='value'
                                                />
                                            </Box>

                                            <Box height='32.5px' mr='10px' onClick={() => setSelectedWelcomesToList()} className={"actionIcon p-2 bg-success"} opacity={"1"} justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr='5px' ml='5px' justifyContent="center">
                                                    <i className={"text-white fa fa-check"} />
                                                </Box>
                                            </Box>

                                            <Box height='32.5px' onClick={() => { setSelectedWelcomes([]); setIsWelcomePanelOpen(false) }} className={"actionIcon p-2 bg-danger"} opacity={"1"} justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr='5px' ml='5px' justifyContent="center">
                                                    <i className={"text-white fa fa-times"} />
                                                </Box>
                                            </Box>
                                        </Box>
                                    )
                                }

                            </Box>
                        )
                    }

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                {
                                                    !isDisabledFromLock && (
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoInVehicles.filter(x => x.isSelected).length > 0 && antrepoInVehicles.filter(x => x.isSelected).length == antrepoInVehicles.length} />
                                                            </label>
                                                        </div>
                                                    )
                                                }
                                            </th>
                                            <th>Grup No</th>
                                            <th>Araç / Dorse</th>
                                            <th>Sürücü</th>
                                            <th>Antrepo Giriş Tarihi</th>
                                            <th>Konteyner No</th>
                                            <th>Konteyner Tipi</th>
                                            <th>Araç Geliş Tarihi</th>
                                            <th>Tedarikçi Firma</th>
                                            <th>T1 (Taşıma Senedi)</th>
                                            <th>Tır Karne No</th>
                                            <th>Tahliye Sorumlusu</th>
                                            <th>Rampa No</th>
                                            <th>Operatör</th>
                                            {auth.user.user?.data.roles.find(x => x == "Giriş Faturalandırma İşlemi Yetkisi") && <th>Faturalanmayacak</th>}
                                            <th>Özet Beyan No</th>
                                            <th>Özet Beyan Tarihi</th>
                                            <th>Özet Beyan Sıra No</th>
                                            <th>Özet Beyan Adet</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoInVehicles.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoInVehicles.sort(function (a, b) {
                                                return Helpers.toNumber(a.groupNo) - Helpers.toNumber(b.groupNo);
                                            }).map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            !isDisabledFromLock && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                        <input onChange={() => setItemSelected(item.antrepoInVehicleId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.groupNo}</td>
                                                    <td>{item.vehicleName ?? '-'} / {item.trailerName ?? '-'}</td>
                                                    <td>{item.driverName}</td>
                                                    <td>{Helpers.dateParser(item.antrepoEnteranceDate, true)}</td>
                                                    <td>{item.containerNo}</td>
                                                    <td>{item.containerName}</td>
                                                    <td>{Helpers.dateParser(item.vehicleArriveDate, true)}</td>
                                                    <td>{item.supplierName}</td>
                                                    <td>{item.transportDocumentNo}</td>
                                                    <td>{item.truckReportNo}</td>
                                                    <td>{item.evacuationOfficerName}</td>
                                                    <td>{item.rampName}</td>
                                                    <td>{item.operatorName}</td>
                                                    {
                                                        auth.user.user?.data.roles.find(x => x == "Giriş Faturalandırma İşlemi Yetkisi") && (
                                                            <td>
                                                                <Box flexDirection="row">
                                                                    <Box justifyContent="center">
                                                                        {item.willNotBeInvoiced ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}
                                                                    </Box>
                                                                    {
                                                                        !Helpers.isEmpty(item.willNotBeInvoicedReason) && (
                                                                            <Box ml="5px" justifyContent="center">
                                                                                {item.willNotBeInvoicedReason}
                                                                            </Box>
                                                                        )
                                                                    }
                                                                </Box>
                                                            </td>
                                                        )
                                                    }
                                                    <td>{item.summaryDeclarationNo}</td>
                                                    <td>{Helpers.dateParser(item.summaryDeclarationDate, true)}</td>
                                                    <td className='custom-text-right'>{item.summaryDeclarationOrderNo}</td>
                                                    <td className='custom-text-right'>{item.summaryDeclarationOrderQuantity}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        antrepoInVehicles.length > 0 && (
                                            <tfoot className='text-gray-600 fw-bold'>
                                                <tr style={{ borderTop: '1px solid rgba(0, 0, 0, 0.40)' }}>
                                                    <td className="custom-text-right" colSpan={auth.user.user?.data.roles.find(x => x == "Giriş Faturalandırma İşlemi Yetkisi") ? 18 : 17}>Toplam</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicles.filter(x => x.summaryDeclarationOrderQuantity).map(x => Helpers.toNumber(x.summaryDeclarationOrderQuantity)))}</td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default VehicleInformation;